module.exports = __webpack_public_path__ + "static/media/private-cremation-back.9595ae55.png";